export const ReferralDisclosureAllSetButtonTappedEvent = {
  feature: 'Referral Disclosure',
  event_description: 'referralDisclosureAllSet button tapped',
  object: 'Button',
  action: 'Tapped',
  object_name: 'referralDisclosureAllSetOk',
  screen: 'referralDisclosure',
  screen_name: 'referralDisclosure',
}

export const ReferralDisclosureAllSetContainerViewedEvent = {
  feature: 'Referral Disclosure',
  event_description: 'referralDisclosureAllSet container viewed',
  object: 'Container',
  action: 'Viewed',
  object_name: 'referralDisclosureAllSet',
  screen: 'referralDisclosure',
  screen_name: 'referralDisclosure',
}

export const ReferralDisclosureAgreementScreenViewedEvent = {
  feature: 'Referral Disclosure Agreement',
  event_description: 'referralDisclosureAgreement screen viewed',
  object: 'Screen',
  action: 'Viewed',
  object_name: 'referralDisclosureAgreement',
  screen: 'referralDisclosureAgreement',
  screen_name: 'referralDisclosureAgreement',
}
